import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { ControlsModule } from "src/app/controls/controls.module";
import { SharedModule } from "src/app/shared/shared.module";
import { TranslateModule } from "@ngx-translate/core";
import { LearnsetsListComponent } from "src/app/shared/learnsets-list/learnsets-list.component";
import { ExamViewComponent } from "./exam-view.component";
import { ExamRunComponent } from "./exam-run/exam-run.component";
import { ExamResultComponent } from "./exam-result/exam-result.component";
import { ExamResultListComponent } from "./exam-result-list/exam-result-list.component";

@NgModule({
  declarations: [
    ExamViewComponent,
    ExamRunComponent,
    ExamResultComponent,
    ExamResultListComponent
  ],
  imports: [
    CommonModule,
    ControlsModule,
    SharedModule,
    TranslateModule,
    LearnsetsListComponent
  ],
  exports: [
    ExamViewComponent,
    ExamRunComponent,
    ExamResultComponent,
    ExamResultListComponent
  ]
})
export class ExamViewModule { }